export const APP_MONITOR_ID = process.env.APP_MONITOR_ID as string;
export const APPLICATION_VERSION = process.env.APPLICATION_VERSION as string;
export const ENDPOINT = process.env.ENDPOINT as string;
export const GUEST_ROLE_ARN = process.env.GUEST_ROLE_ARN as string;
export const IDENTITY_POOL_ID = process.env.IDENTITY_POOL_ID as string;
export const SESSION_SAMPLE_RATE = Number(process.env.SESSION_SAMPLE_RATE);
export const AWS_REGION = process.env.AWS_REGION as string;
export const APP_ENV_TYPE = process.env.APP_ENV_TYPE;
